import React from 'react';
import { useState, useEffect } from 'react';
import {
  Card, Container, ModalBody, ModalFooter, Modal,
  Row, Button, Spinner, FormGroup, Col, Input, Label, ModalHeader
} from "reactstrap";
import { NavLink as NavLinkRRD, useHistory } from "react-router-dom";
import { Form, Field } from "react-final-form";
import dataProvider from "dataProvider";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import auth from "authProvider";
import { CountryDropdown } from 'react-country-region-selector';



const TenantCreate = (props) => {
  const history = useHistory();
  const [tenants, setTenants] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectednationality, setSelectednationality] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [contract, setContract] = useState(0);
  const [login, setLogin] = useState(0);
  const [locations, setLocations] = useState(false);
  const [selected_location, setSelected_location] = useState(false);
  const [selected_sublocation, setSelected_sublocation] = useState(false);
  const [filtered_sublocation, setFiltered_sublocation] = useState(false);
  const [status, setStatus] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [erroropen, setErroropen] = useState(false);
  const [locationopen, setLocationopen] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [opens, setOpens] = useState(false)

  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  const currentYear = new Date().getFullYear(); // 2020
  const previousYear = currentYear - 2;

  useEffect(() => {
    dataProvider.getList('locations/list', { params: { pagination: { page: 1, perPage: 2000 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setLocations(data[0].data); })

    dataProvider.getList('tenants', { params: { pagination: { page: 1, perPage: 20 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => {
        setTenants(data);
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      });
  }, [props]);
  const onSubmit = values => {
    // let newListlocation = tenants.filter(item => item.location === selected_location && item.sub_location === selected_sublocation && item.villa === values?.villa)
    // if (newListlocation.length > 0) {
    //   setLocationopen(true);
    //   return;
    // }
    // else {
    setLoading(true)
    dataProvider.create('tenants', { params: { ...values, location: selected_location, sub_location: selected_sublocation, indefinite_contract: contract, contract_started: startDate, contract_ended: endDate, nationality: selectednationality, status: status, logindetails: login } })
      .then(({ data }) => {
        setLoading(false)
        setSucess(true)
        setTimeout(() => Push(), 1000);
      })
      .catch(error => {
        if (error?.response?.data?.msg === 'This Sub Location or Villa No already registerd with another tenant. Please contact administartor for further details.') {
          setLocationopen(true);
        }
        if (error?.response?.data?.msg === 'User Already Exists') {
          setErroropen(true)
        }
        setLoading(false)
      });
    // };
  }

  const indefinite_contract = (data) => {
    if (data === true) {
      setContract(1)
    }
    else {
      setContract(0)
    }
  }
  const login_details = (data) => {
    if (data === true) {
      setLogin(1)
    }
    else {
      setLogin(0)
    }
  }
  const handleClose = () => {
    setErroropen(false);
  };
  const Locationmodalclose = () => {
    setLocationopen(false);
  };
  const Push = () => {
    setSucess(false)
    history.push("/tenants");
  }
  const opendropdownservice = () => {
    setOpens(!opens)
  }
  const Selected_locationchange = (val) => {
    setSelected_location(val);
    setFiltered_sublocation(locations?.filter(item => (item._id === val)));

  }
  const Selected_sublocationchange = (val) => {
    setSelected_sublocation(val);
  }

  const required = value => (value ? undefined : 'Required')
  const mustBeNumber = value => (isNaN(value) ? 'Must be a number' : undefined)
  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h2 className="mb-0" style={{ color: 'white', alignContent: 'flex-start', fontSize: '1.5rem' }}>CREATE A NEW TENANT</h2>
            </Row>
          </div>
        </Container>
      </div>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <Row>
                <div className="col">
                  <Card className="shadow">
                    <Form
                      onSubmit={onSubmit}
                      validate={values => {
                        const errors = {};
                        function validateEmail(email) {
                          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                          return re.test(String(email).toLowerCase());
                        }
                        function validatePhone(phone) {
                          var ph = /^(\d{8}(\,\d{8}){0,2})$/;
                          return ph.test(String(phone).toLowerCase());
                        }
                        function validateContract(contrct_number) {
                          var cn = /^(\d{8}(\,\d{8}){0,2})$/;
                          return cn.test(String(contrct_number).toLowerCase());
                        }
                        function validateContract(electricity_number) {
                          var en = /^(\d{8}(\,\d{8}){0,2})$/;
                          return en.test(String(electricity_number).toLowerCase());
                        }
                        function validateContract(water_number) {
                          var wn = /^(\d{8}(\,\d{8}){0,2})$/;
                          return wn.test(String(water_number).toLowerCase());
                        }
                        if (!values.fullname) {
                          errors.fullname = "required";
                        }
                        if (!values.phone) {
                          errors.phone = "Required";
                        } else if (!validatePhone(values.phone)) {
                          errors.phone = "Enter a valid phonenumber";
                        }
                        if (!values.contrct_number) {
                          errors.contrct_number = "Required";
                        } else if (!validateContract(values.contrct_number)) {
                          errors.contrct_number = "Enter a valid number";
                        }
                        if (!values.electricity_number) {
                          errors.electricity_number = "Required";
                        }
                        if (!values.water_number) {
                          errors.water_number = "Required";
                        }
                        if (!values.email) {
                          errors.email = "required";
                        } else if (!validateEmail(values.email)) {
                          errors.email = "Enter a valid email address";
                        }
                        if (!values.username) {
                          errors.username = "required";
                        }
                        if (!values.password) {
                          errors.password = "required";
                        }
                        return errors;
                      }}
                      render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} style={{ padding: '20px' }}>
                          <div className="pl-lg-4">
                            <Row>
                              <Col md="12">
                                <FormGroup>
                                  <Label for="name" style={{ fontSize: ' 0.8125rem' }}>Full Name</Label>
                                  <Field name="fullname">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="fullname"
                                          placeholder="Enter Tenant FullName"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Phone Number</Label>
                                  <Field name="phone">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="phone"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="Enter Phone Number"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="email">E-mail</Label>
                                  <Field name="email">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="email"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="Enter email address"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="nation">Nationality</Label>
                                  <Field name="nationality" >
                                    {({ input, meta, value }) => (
                                      <div style={{ paddingLeft: 0 }}>
                                        <CountryDropdown
                                          required
                                          style={{
                                            padding: '8px',
                                            width: '100%',
                                            borderRadius: '5px',
                                            borderColor: '#ccc',
                                          }}
                                          value={selectednationality}
                                          onChange={(e) => setSelectednationality(e)} />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }}>Location</Label>
                                  <Field name="location" >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input type="select" name="location"
                                          onChange={(e) => Selected_locationchange(e.target.value)} id="category" style={{ color: 'black', borderRadius: 10 }}>
                                          <option value="">--Select Location--</option>
                                          {locations && locations.map(item => (
                                            <option value={item._id}>{item.location}</option>
                                          ))}
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="category">sublocation</Label>
                                  <Field name="sub_location" >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <Input required type="select" name="sub_location" onChange={(e) => Selected_sublocationchange(e.target.value)} style={{ color: 'black', paddingLeft: 25, borderRadius: 10 }}>
                                          <option value="">--Select Location--</option>
                                          {filtered_sublocation && filtered_sublocation.map(item => (
                                            <>
                                              {item.children && item.children.length > 0 && (
                                                item.children.map((child) => (
                                                  <option value={child._id}>{child.location}</option>
                                                ))
                                              )}
                                            </>
                                          ))}
                                        </Input>
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="email">Villa no</Label>
                                  <Field name="villa" >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="Villa no"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="email">No of peoples</Label>
                                  <Field name="people_count" validate={composeValidators(required, mustBeNumber)}>
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="people_count"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="01"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup >
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="role">Contract Start Date</Label>
                                  <Field name="contract_started" >
                                    {({ input, meta, value }) => (
                                      <div>
                                        <DatePicker
                                          selected={startDate}
                                          style={{ padding: 20 }}
                                          onChange={(date) => setStartDate(date)}
                                          dateFormat='dd/MM/yyyy'
                                          placeholderText="DD/MM/YYYY"
                                          isClearable
                                          minDate={(new Date('01-01-' + previousYear))}
                                          // minDate={new Date()}
                                          required={true}
                                          className="datePicker"
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup check>
                                  <div style={{ float: 'right', marginLeft: 20 }}>
                                    <Input type="checkbox" name="indefinite_contract"
                                      onChange={(e) => indefinite_contract(e.target.checked)} />
                                    <span style={{ fontSize: '11px', listStyle: 'none', color: '#12ACF6' }}>INDEFINITE CONTRACT</span>
                                  </div>
                                </FormGroup>
                                {contract === 0 ?
                                  <FormGroup >
                                    <Label style={{ fontSize: ' 0.8125rem' }} for="role">Contract End Date</Label>
                                    <Field name="contract_ended" >
                                      {({ input, meta, value }) => (
                                        <div  >
                                          <DatePicker selected={endDate}
                                            style={{ padding: 20 }}
                                            onChange={(date) => setEndDate(date)}
                                            dateFormat='dd/MM/yyyy'
                                            placeholderText="DD/MM/YYYY"
                                            required={true}
                                            minDate={startDate}
                                            isClearable
                                            className="datePicker"
                                          />
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                  : <FormGroup >
                                    <Label style={{ fontSize: ' 0.8125rem' }} >Contract End Date</Label>
                                    <Field name="contract_ended" >
                                      {({ input, meta, value }) => (
                                        <div  >
                                          <DatePicker selected={endDate}
                                            style={{ padding: 20 }} onChange={(date) => setEndDate(date)}
                                            dateFormat='dd/MM/yyyy'
                                            placeholderText="DD/MM/YYYY"
                                            disabled={true}
                                            isClearable
                                            value={null}
                                            className="datePicker"
                                          />
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                }
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="contract">Contract Number</Label>
                                  <Field name="contrct_number"  >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="contrct_number"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="Contract Number"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="electricity number">Electricity Number</Label>
                                  <Field name="electricity_number">
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="electricity_number"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="Electricity Number"
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                              <Col lg="4">
                                <FormGroup>
                                  <Label style={{ fontSize: ' 0.8125rem' }} for="password">Water Number</Label>
                                  <Field name="water_number"  >
                                    {({ input, meta }) => (
                                      <div>
                                        <Input
                                          {...input}
                                          type="text"
                                          name="water_number"
                                          style={{ color: 'black', borderRadius: 10 }}
                                          placeholder="Water Authority No."
                                          invalid={meta.error && meta.touched}
                                        />
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </FormGroup>
                              </Col>
                            </Row>
                          </div>
                          <Col md="12">
                            <label style={{ marginLeft: 20, color: '#ccc' }}>LOGIN DETAILS</label>
                            <div className="pl-lg-4" style={{ marginTop: 20 }}>
                              <Row>
                                <Col lg="4">
                                  <FormGroup>
                                    <Label style={{ fontSize: ' 0.8125rem' }} for="username">User Name</Label>
                                    <Field name="username">
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            type="text"
                                            style={{ color: 'black' }}
                                            name="username"
                                            placeholder="Enter User Name"
                                            invalid={meta.error && meta.touched}
                                          />
                                          {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="4">
                                  <FormGroup>
                                    <Label style={{ fontSize: ' 0.8125rem' }} for="password">Password</Label>
                                    <Field name="password">
                                      {({ input, meta }) => (
                                        <div>
                                          <Input
                                            {...input}
                                            type="password"
                                            name="password"
                                            style={{ color: 'black', borderRadius: 10 }}
                                            placeholder="Enter Password"
                                            invalid={meta.error && meta.touched}
                                          />
                                          {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="4" style={{ marginTop: 20 }}>
                                  <Field name="login">
                                    {({ input, meta }) => (
                                      <div>
                                        <FormGroup check>
                                          <Input type="checkbox"
                                            value="login"
                                            onChange={(e) => login_details(e.target.checked)} />
                                          {' '}
                                          <h6 style={{ marginTop: 15, color: '#2FBBC1' }}>SEND LOGIN DETAILS TO EMAIL</h6>
                                        </FormGroup>
                                        {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                                      </div>
                                    )}
                                  </Field>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          <Col md="4" >
                            <div style={{ paddingBottom: '30px', padding: 20 }}>
                              <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: loading ? 'green' : '#044057', color: 'white', width: '100%', borderRadius: '10px', border: 0, padding: '15px 30px 15px 30px' }} >
                                {loading && (<Spinner as="span" size="sm" aria-hidden="true" style={{ marginRight: 20, color: 'white' }} />)}
                                SUBMIT</Button>{' '}
                            </div>
                          </Col>
                        </form>
                      )}
                    />
                  </Card>
                </div>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      <Modal isOpen={erroropen} size="sm">
        <ModalHeader></ModalHeader>
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'red' }}>User Already Exists</ModalBody>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: 10 }}>
          <Button onClick={handleClose} style={{ backgroundColor: '#09577C', color: 'white', border: 0, paddingLeft: 15, paddingRight: 15 }} type="button">
            OK
          </Button>
        </div>
      </Modal>
      <Modal isOpen={locationopen} size="sm">
        <ModalHeader></ModalHeader>
        <ModalBody style={{ backgroundColor: 'rgb(245 242 243)', color: 'red', fontSize: '0.85rem' }}>This Sub Location or Villa No already registerd with another tenant. Please contact administartor for further details</ModalBody>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: 10 }}>
          <Button onClick={Locationmodalclose} style={{ backgroundColor: '#09577C', color: 'white', border: 0, padding: '10px 20px 10px 20px' }} type="button">
            OK
          </Button>
        </div>
      </Modal>
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default TenantCreate;
